/**
 * Created by lihanying on 2017/7/6.
 */
import 'whatwg-fetch'
import moment from 'moment'
import { message } from 'antd'
import { API_DOMAIN } from '../../config'
import {
  fetchData,
  postData,
  changeToDecimal,
  getCurrentTimeByType,
  fenToYuan,
  round,
} from '../../util/index'

import {
  GETPAYMENTLIST,
  GETBUSINESS,
  GETPERIOD,
  GETRECORDDETAIL,
  GETINCOMESUM,
  CLUB_ID,
  UPDATE_PURCHASE_SERVICES,
  GETBILLREMARKS,
  GETBILLREMARKSUM,
} from './constants'
import { exportData } from '../../util'
import { purchaseServices } from '../../api/employee'

export const getPaymentList = (payload) => {
  return {
    type: GETPAYMENTLIST,
    payload,
  }
}
export const getBusiness = (payload) => {
  return {
    type: GETBUSINESS,
    payload,
  }
}
export const getIncomeSum = (payload) => {
  return {
    type: GETINCOMESUM,
    payload,
  }
}
export const getBillRemarks = (payload) => {
  return {
    type: GETBILLREMARKS,
    payload,
  }
}
export const getBillRemarkSum = (payload) => {
  return {
    type: GETBILLREMARKSUM,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}
export const getRecordDetail = (payload) => {
  return {
    type: GETRECORDDETAIL,
    payload,
  }
}

export const updatePurchaseServices = (payload) => {
  return {
    type: UPDATE_PURCHASE_SERVICES,
    payload,
  }
}

//支付方式
export function fetchPaymentList(id) {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem(CLUB_ID)
    const endpoint = `${API_DOMAIN}/BusinessApi/IncomeBusiness/club_id/${club}/typeId/${id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getPaymentList(data.payList))
    })
  }
}

//显示
export function fetchIncomeBusiness(body) {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/IncomeBusiness`
    const typeList = body.type.length === 0 ? [''] : body.type
    body.club_id = sessionStorage.getItem(CLUB_ID)
    let list = []
    let incomeList = []
    for (let i = 0, len = typeList.length; i < len; i++) {
      body.type = typeList[i]
      const item = await postData(endpoint, 'POST', JSON.stringify(body)).then(
        (data) => {
          try {
            data.list &&
              data.list.forEach((listItem) => {
                listItem.bills &&
                  listItem.bills.forEach((billItem) => {
                    billItem.amount = fenToYuan(billItem.amount)
                  })
              })
            incomeList.push(data.incomeSum)
            return data.list.map((item) => {
              return item
            })
          } catch (e) {
            console.log('error:', e)
          }
        }
      )
      list = list.concat(item)
    }
    dispatch(getIncomeSum(incomeList))
    dispatch(getBusiness(list))
    return true
  }
}

export function fetchTimePeriod(type) {
  return (dispatch, getState) => {
    dispatch(getPeriod(getCurrentTimeByType(type)))
  }
}

//将返回的数据转换为金额正常的数据
function changeToDecimalData(data) {
  let newData = data
  newData.list = newData.list.map((item) => {
    let itemSource = item
    return itemSource
  })
  newData.goodsList = newData.goodsList.map((item) => {
    let itemSource = item
    return itemSource
  })
  return newData
}
//订单号
export function fetchRecordDetails(temporary_number) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/RecordDetails/sn/${temporary_number}`
    return fetchData(endpoint).then((data) => {
      let changedData = changeToDecimalData(data)
      dispatch(getRecordDetail(changedData))
    })
  }
}

//套餐消费的订单号
export function fetchMealRecordDetails(temporary_number) {
  const endpoint = `${API_DOMAIN}/BusinessApi/searchPrepaidDetails`
  return postData(endpoint, 'POST', JSON.stringify({ temporary_number })).then(
    (data) => {
      data.data.list &&
        data.data.list.forEach((listItem) => {
          listItem.bills &&
            listItem.bills.forEach((billItem) => {
              billItem.amount = fenToYuan(billItem.amount)
            })
        })
      return data.data.list
    }
  )
}

export function fetchSnDetails(account) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/SnDetails`
    return postData(endpoint, 'POST', JSON.stringify({ sn: account })).then(
      (data) => {
        let changedData = changeToDecimalData(data.data)
        dispatch(getRecordDetail(changedData))
      }
    )
  }
}

// 导出俱乐部订单详情记录
export function exportPurchaseRecord(body) {
  const endpoint = `${API_DOMAIN}/Home/BusinessApi/exportPurchaseRecord`
  return exportData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
    return data
  })
}

// 服务消费记录
export function getPurchaseServices(body) {
  return async (dispatch, getState) => {
    const { status, detail, data } = await purchaseServices(body)
    if (status != 1) {
      return []
    }
    const newData = []
    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      const { member, employee, service } = item
      newData.push({
        id: service.id,
        account: member.account,
        memberName: member.memberName,
        employeeName:  employee && employee.name ? employee.name : "-",
        tableTitle: service.tableTitle,
        startTime: moment(service.startTime).format('YYYY-MM-DD HH:mm'),
        endTime: moment(service.endTime).format('YYYY-MM-DD HH:mm'),
        identityType: service.identityType == 1 ? '助教' : '记分员',
        duration: round(service.duration / 3600, 2),
        amount: round(service.amount / 100, 2),
        unitAmount: round(service.unitAmount / 100),
      })
    }
    return newData
  }
}

export function settingsPurchases(data) {
  return async (dispatch, getState) => {
    dispatch(updatePurchaseServices(data))
  }
}

// 备注记录查询
export function fetchBillRemarks(body) {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/BillRemarks`
    const params = {
      club_id: body.club_id,
      start_time: body.start_time,
      end_time: body.end_time,
      payment_type: body.payment_type,
      statisticType: body.statisticType,
    }
    const data = await postData(endpoint, 'POST', JSON.stringify(params))
    dispatch(getBillRemarkSum([data.incomeSum]))
    dispatch(getBillRemarks(data.list))
    return true
  }
}

// 导出备注记录
export function exportBillRemarks(body) {
  const endpoint = `${API_DOMAIN}/BusinessApi/exportBillRemarks`
  return exportData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
    return data
  })
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/action.js